// libraries
import { generateUri } from "@cloudspire/legacy-shared/src/libraries";

// helpers
import bookingDelegationGetChannelId from "./delegation/getChannelId";
import channelBuildHostFromConfiguration from "@cloudspire/shared/helpers/channel/buildHostFromConfiguration";

/**
 * Récupère l’URL à utiliser pour rediger l’utilisateur vers la centrale de réservation.
 * @param {object} param0
 * @param {object} param0.parameterList
 * @param {string} param0.locale
 * @param {object} param0.bookingRouter
 * @param {object} param0.configuration
 * @param {object} param0.room
 * @return {string}
 */
export default function bookingGetCreateUrl({
  parameterList,
  locale,
  bookingRouter,
  configuration,
  room,
}) {
  let host;
  const query = {};
  const delegatedChannelId = bookingDelegationGetChannelId({
    configuration,
    room,
  });
  if (
    // Si le channel courant délégue la prise de réservation
    delegatedChannelId !== configuration.channel.id
  ) {
    host = channelBuildHostFromConfiguration({
      channelConfiguration: configuration,
      websiteType: "booking",
      bookingDelegationChannelId: delegatedChannelId,
    });
  }

  return generateUri({
    router: bookingRouter,
    name: "App.Action.Booking.Create",
    parameters: {
      lang: locale,
    },
    query: {
      ...query,
      roomReference: parameterList?.roomReference,
      adults: parameterList?.adults,
      checkin: parameterList?.checkin,
      checkout: parameterList?.checkout,
      nature: parameterList?.nature,
      customerHotelSelectionId: parameterList?.customerHotelSelectionId,
      options: (parameterList?.optionList ?? []).reduce((options, option) => {
        options[option.id] = option.quantity;

        return options;
      }, {}),
    },
    host,
  });
}
